import React, { Component } from "react";
import Modal from "reactstrap/es/Modal";
import { ModalBody, ModalHeader, ModalFooter, Button } from "reactstrap";

// 'GE', 'TA', 'KK', 'OLI'
class CarFind extends Component {
  constructor(props) {
    super(props);
    this.state = {
      carTypes: ["เก๋ง", "กระบะ", "แวน"],
      carType: "เก๋ง",
      carLeasing: "SCB",
      leasingBanks: ["SCB", "AY", "TTB", "KK", "OAT", "CIMB", "KL", "BL"],
      leasingPercent: 90,
      leasingPercents: [
        { percent_id: 7, percent_name: "120%", percent_value: 120 },
        { percent_id: 1, percent_name: "110%", percent_value: 110 },
        { percent_id: 2, percent_name: "95%", percent_value: 95 },
        { percent_id: 3, percent_name: "90%", percent_value: 90 },
        { percent_id: 4, percent_name: "85%", percent_value: 85 },
        { percent_id: 5, percent_name: "80%", percent_value: 80 },
        { percent_id: 6, percent_name: "75%", percent_value: 75 },
        { percent_id: 8, percent_name: "70%", percent_value: 70 },
      ],
      carDown: "",
      promotionOption: "",
      promotionOptions: [
        { value: "", label: "ทั้งหมด" },
        { value: "pro", label: "มีโปร" },
        { value: "nopro", label: "ไม่มีโปร" },
      ],
    };
    this.toggle = this.toggle.bind(this);
    this.carFindCriteria = this.carFindCriteria.bind(this);
    this.onInputChange = this.onInputChange.bind(this);
    this.loadCarBankLeasing = this.loadCarBankLeasing.bind(this);
  }

  componentDidMount() {
    // console.log('===componentDidMount')
    // this.loadCarBankLeasing()
  }

  /*componentDidUpdate (prevProps, prevState, snapshot) {
    if(prevState.leasingBanks.length === 0) {
      console.log('===componentDidMount')
      // this.loadCarBankLeasing()
    }
  }*/

  toggle() {
    // let toggle_car_find = !this.props.toggle_car_find
    this.props.handleCarFind(false, null);
  }

  carFindCriteria() {
    // console.log('carFindCriteria')
    const { carType, carLeasing, leasingPercent, carDown, promotionOption } =
      this.state;
    if (carDown === "" || carDown < 0) {
      alert("กรุณากรอกเงินดาวน์");
      return;
    }
    const data = {
      carType,
      carLeasing,
      leasingPercent,
      carDown,
      promotionOption,
    };
    this.props.handleCarFind(false, data);
  }

  onInputChange(event) {
    event.preventDefault();
    // console.log(event.target.name, event.target.value)
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  loadCarBankLeasing() {
    /*console.log('===loadCarBankLeasing')
    axios.get(APIURL + '/car_leasing/banks')
      .then(res => {
        console.log(res.data)
        this.setState({leasingBanks: res.data})
      }).catch(error => {
      this.setState({leasingBanks: []})
    })*/
  }

  render() {
    const carTypes = this.state.carTypes.map((carType, index) => (
      <option key={index} value={carType}>
        {carType}
      </option>
    ));

    const leasingBanks = this.state.leasingBanks.map((leasingBank, index) => (
      <option key={index} value={leasingBank}>
        {leasingBank}
      </option>
    ));

    const leasingPercents = this.state.leasingPercents.map((per, index) => (
      <option key={index} value={per.percent_value}>
        {per.percent_name}
      </option>
    ));

    const proOptions = this.state.promotionOptions.map((option, index) => (
      <option key={index} value={option.value}>
        {option.label}
      </option>
    ));

    return (
      <Modal
        isOpen={this.props.toggle_car_find}
        toggle={this.toggle}
        className={"modal-lg xs"}
      >
        <ModalHeader toggle={this.toggle}>ค้นหารถ</ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="col-3 text-right">ประเภทรถ :</div>
            <div className="col-8">
              <select
                name="carType"
                className="form-control"
                value={this.state.carType}
                onChange={this.onInputChange}
              >
                {carTypes}
              </select>
            </div>
          </div>
          <div className="row pt-2">
            <div className="col-3 text-right">ธนาคาร :</div>
            <div className="col-8">
              <select
                name="carLeasing"
                className="form-control"
                value={this.state.carLeasing}
                onChange={this.onInputChange}
              >
                {leasingBanks}
              </select>
            </div>
          </div>
          <div className="row pt-2">
            <div className="col-3 text-right">เปอร์เซ็นต์ :</div>
            <div className="col-8">
              <select
                name="leasingPercent"
                className="form-control"
                value={this.state.leasingPercent}
                onChange={this.onInputChange}
              >
                {leasingPercents}
              </select>
            </div>
          </div>
          <div className="row pt-2">
            <div className="col-3 text-right">เงินดาวน์ :</div>
            <div className="col-8">
              <input
                value={this.state.carDown}
                name="carDown"
                className="form-control"
                onChange={this.onInputChange}
              />
            </div>
          </div>
          {/* <div className="row pt-2">
            <div className="col-3 text-right">โปร :</div>
            <div className="col-8">
              <select name="promotionOption"
                      className="form-control"
                      value={this.state.promotionOption}
                      onChange={this.onInputChange}
              >
                {proOptions}
              </select>
            </div>
          </div> */}
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={this.carFindCriteria}>
            ตกลง
          </Button>{" "}
          <Button color="secondary" onClick={this.toggle}>
            ยกเลิก
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default CarFind;
